module.exports = __webpack_public_path__ + "static/media/BG_41.cc1a6466.png";